import OrderCancel from '../../components/pages/orders/OrderCancel.vue'

export default {
  components: {
    OrderCancel
  }
}
